export default "__VITE_ASSET__BdWVPxXJ__"